<ng-template #fetching>
    <div class="fetching">
        <app-loading-dots></app-loading-dots>
    </div>
</ng-template>

<div class="same-day-delivery-facet">
    <ng-container *ngIf="timeLeft$ | async as timeLeft; else fetching">
        <label class="checkbox-wrapper" [class.checkbox-wrapper--disabled]="checkboxControl.disabled">
            <input
                class="kk-checkbox kk-visuallyhidden"
                type="checkbox"
                [formControl]="checkboxControl"
                name="'same-day-delivery-facet'"
            />
            <span class="kk-checkbox__element checkbox-element">
                <span class="kk-checkbox__icon">
                    <app-svg-icon iconName="tick"></app-svg-icon>
                </span>
            </span>
            <span class="text display-label">
                {{
                    (timeLeft.onTimeForSameDayDelivery
                            ? 'sameDayDelivery.labels.deliveryToday'
                            : 'sameDayDelivery.labels.deliveryTomorrow'
                    ) | translateSafe
                }}
            </span>
        </label>
        <div class="tooltip-wrapper">
            <app-tooltip>
                <span
                    [innerHTML]="
                        'sameDayDelivery.tooltipText'
                            | translateSafe: { deliveryCutoffTime: timeLeft.secondsLeft | timeLimit | date: 'HH' }
                            | safe: 'html'
                    "
                ></span>
            </app-tooltip>
        </div>

        <div class="form-group">
            <div class="input-wrapper">
                <input
                    type="text"
                    class="zipcode-input"
                    [formControl]="zipCodeControl"
                    maxlength="4"
                    [placeholder]="'sameDayDelivery.placeholders.zipCode' | translateSafe"
                    autocomplete="off"
                />
            </div>

            <div class="button-wrapper">
                <button
                    *ngIf="(zipCodeControl.valueChanges | async)?.length || zipCodeControl.value"
                    class="clear-button"
                    (click)="onClearField()"
                >
                    <app-svg-icon iconName="close"></app-svg-icon>
                </button>
            </div>
        </div>

        <div
            class="kk-status"
            [ngClass]="{
                'kk-status--idle': sameDayDeliveryStatus === 'Idle',
                'kk-status--valid': sameDayDeliveryStatus === 'Valid',
                'kk-status--invalid': sameDayDeliveryStatus === 'Invalid'
            }"
        >
            @if (sameDayDeliveryStatus === 'Valid') {
                <app-svg-icon iconName="tick"></app-svg-icon>
            } @else {
            <app-svg-icon iconName="error"></app-svg-icon>
        }
        </div>
    </ng-container>
</div>
